// extracted by mini-css-extract-plugin
module.exports = {"addedPropertiesTable":"addedPropertiesTable_addedPropertiesTable__iqto_"};